/* tslint:disable */
/* eslint-disable */
/**
 * Ampersand public API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { IntegrationProxy } from './IntegrationProxy';
import {
    IntegrationProxyFromJSON,
    IntegrationProxyFromJSONTyped,
    IntegrationProxyToJSON,
} from './IntegrationProxy';
import type { IntegrationRead } from './IntegrationRead';
import {
    IntegrationReadFromJSON,
    IntegrationReadFromJSONTyped,
    IntegrationReadToJSON,
} from './IntegrationRead';
import type { IntegrationSubscribe } from './IntegrationSubscribe';
import {
    IntegrationSubscribeFromJSON,
    IntegrationSubscribeFromJSONTyped,
    IntegrationSubscribeToJSON,
} from './IntegrationSubscribe';
import type { IntegrationWrite } from './IntegrationWrite';
import {
    IntegrationWriteFromJSON,
    IntegrationWriteFromJSONTyped,
    IntegrationWriteToJSON,
} from './IntegrationWrite';
import type { WatchSchema } from './WatchSchema';
import {
    WatchSchemaFromJSON,
    WatchSchemaFromJSONTyped,
    WatchSchemaToJSON,
} from './WatchSchema';

/**
 * 
 * @export
 * @interface Integration1
 */
export interface Integration1 {
    /**
     * 
     * @type {string}
     * @memberof Integration1
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof Integration1
     */
    provider: string;
    /**
     * 
     * @type {string}
     * @memberof Integration1
     */
    displayName?: string;
    /**
     * 
     * @type {string}
     * @memberof Integration1
     */
    module?: string;
    /**
     * 
     * @type {IntegrationRead}
     * @memberof Integration1
     */
    read?: IntegrationRead;
    /**
     * 
     * @type {IntegrationWrite}
     * @memberof Integration1
     */
    write?: IntegrationWrite;
    /**
     * 
     * @type {IntegrationProxy}
     * @memberof Integration1
     */
    proxy?: IntegrationProxy;
    /**
     * 
     * @type {IntegrationSubscribe}
     * @memberof Integration1
     */
    subscribe?: IntegrationSubscribe;
    /**
     * 
     * @type {WatchSchema}
     * @memberof Integration1
     */
    watchSchema?: WatchSchema;
}

/**
 * Check if a given object implements the Integration1 interface.
 */
export function instanceOfIntegration1(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "name" in value;
    isInstance = isInstance && "provider" in value;

    return isInstance;
}

export function Integration1FromJSON(json: any): Integration1 {
    return Integration1FromJSONTyped(json, false);
}

export function Integration1FromJSONTyped(json: any, ignoreDiscriminator: boolean): Integration1 {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'name': json['name'],
        'provider': json['provider'],
        'displayName': !exists(json, 'displayName') ? undefined : json['displayName'],
        'module': !exists(json, 'module') ? undefined : json['module'],
        'read': !exists(json, 'read') ? undefined : IntegrationReadFromJSON(json['read']),
        'write': !exists(json, 'write') ? undefined : IntegrationWriteFromJSON(json['write']),
        'proxy': !exists(json, 'proxy') ? undefined : IntegrationProxyFromJSON(json['proxy']),
        'subscribe': !exists(json, 'subscribe') ? undefined : IntegrationSubscribeFromJSON(json['subscribe']),
        'watchSchema': !exists(json, 'watchSchema') ? undefined : WatchSchemaFromJSON(json['watchSchema']),
    };
}

export function Integration1ToJSON(value?: Integration1 | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'name': value.name,
        'provider': value.provider,
        'displayName': value.displayName,
        'module': value.module,
        'read': IntegrationReadToJSON(value.read),
        'write': IntegrationWriteToJSON(value.write),
        'proxy': IntegrationProxyToJSON(value.proxy),
        'subscribe': IntegrationSubscribeToJSON(value.subscribe),
        'watchSchema': WatchSchemaToJSON(value.watchSchema),
    };
}

